import { ColumnWidthOutlined } from '@ant-design/icons-vue'
import { Dropdown, Menu, Tooltip } from 'ant-design-vue'
import type { SizeType } from 'ant-design-vue/lib/config-provider'
import { computed, defineComponent, type PropType } from 'vue'
import styles from './headerBtn.module.less'
const SIZE = {
  large: '默认',
  middle: '中等',
  small: '紧凑'
}
export default defineComponent({
  name: 'TableSize',
  props: {
    size: {
      type: String as PropType<SizeType>,
      default: 'large'
    }
  },
  emits: ['update:size'],
  setup(props, ctx) {
    const selectedKeys = computed(() => [props.size])
    const slots = {
      overlay: () => (
        // @ts-ignore
        <Menu selectedKeys={selectedKeys.value} onClick={({ key }) => ctx.emit('update:size', key)}>
          {Object.keys(SIZE).map(key => (
            <Menu.Item key={key} class={styles.sizeItem}>
              {SIZE[key]}
            </Menu.Item>
          ))}
        </Menu>
      )
    }
    return () => (
      <Dropdown v-slots={slots} trigger={['click']}>
        <Tooltip title='表格尺寸' placement='top'>
          <div class={styles.btn}>
            <ColumnWidthOutlined />
          </div>
        </Tooltip>
      </Dropdown>
    )
  }
})
